<template>
  <div class="errPage-container">
    
    <el-row>
      <el-col :span="12">
        <h1 class="text-jumbo text-ginormous">Oops!</h1>
        <h2>你没有权限</h2>
        <h6>如有不满请联系你领导</h6>
        <ul class="list-unstyled">
          <li>或者你可以其他账号登录:</li>
          <li class="link-type">
            <router-link to="/login">去登录</router-link>
          </li>
           <li class="link-type">
           	<a href="https://home.yxcg.net/#/">返回小森林管理平台</a>
          </li>
        </ul>
      </el-col>
      <el-col :span="12">
        <img src="../assets/401.gif" width="313" height="428" alt="Girl has dropped her ice cream.">
      </el-col>
    </el-row>

    <el-dialog title="随便看" :visible.sync="dialogVisible" size="large">
      <img class="pan-img" :src="ewizardClap">
    </el-dialog>
  </div>
</template>

<script>
  
    export default {
      data() {
        return {
          ewizardClap: 'https://wpimg.wallstcn.com/007ef517-bafd-4066-aae4-6883632d9646',
          dialogVisible: false
        }
      },
      methods: {
      
      }
    };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .errPage-container {
    width: 800px;
    margin: 100px auto;
    .pan-back-btn {
      background: #008489;
      color: #fff;
    }
    .pan-gif {
      margin: 0 auto;
      display: block;
    }
    .pan-img {
      display: block;
      margin: 0 auto;
    }
    .text-jumbo {
      font-size: 60px;
      font-weight: 700;
      color: #484848;
    }
    .list-unstyled {
      font-size: 14px;
      li {
        padding-bottom: 5px;
      }
      a {
        color: #008489;
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// 401.vue?081611be